<script>
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import BaseDatatable from "@components/base-datatable";
import { invoiceControlManagement } from "@state/helpers";
import CustomMultiselect from "@/src/components/CustomMultiselect.vue";
import DatePickerRange from "@components/form/DatePickerRange.vue";
export default {
  components: { Layout, PageHeader, BaseDatatable, CustomMultiselect, DatePickerRange },
  data() {
    return {
      title: "Invoice Control",
      tableHeaders: [
        {
          key: "id_unidad_precio",
          label: this.$t("Unidad de medida"),
        },
        {
          key: "cant_base",
          label: this.$t("Cantidad base"),
        },
        {
          key: "precio",
          label: this.$t("Precio"),
          formatter: (value) => {
            return this.$formatDollar(value);
          },
        },
        {
          key: "referencia_item",
          label: this.$t("SKU"),
        },
        {
          key: "iva",
          label: this.$t("IVA"),
        },
        {
          key: "descuento",
          label: this.$t("Descuento"),
        },
        // {
        //   key: "EAN",
        //   label: this.$t("EAN"),
        // },
        {
          key: "vlr_bruto",
          label: this.$t("Valor bruto"),
          formatter: (value) => {
            return this.$formatDollar(value);
          },
        },
      ],
      tableHeadersEnglish: [
        {
          key: "und",
          label: this.$t("Unidad de medida"),
        },
        {
          key: "qty",
          label: this.$t("Cantidad base"),
        },
        {
          key: "price",
          label: this.$t("Precio"),
          formatter: (value) => {
            return this.$formatDollar(value);
          },
        },
        {
          key: "code",
          label: this.$t("EAN"),
        },
        {
          key: "iva",
          label: this.$t("IVA"),
        },
        {
          key: "discount",
          label: this.$t("Descuento"),
        },

        {
          key: "vlr_bruto",
          label: this.$t("Valor bruto"),
          formatter: (value) => {
            return this.$formatDollar(value);
          },
        },
      ],
      action: "",

      toDelete: {},
      isSubmitting: false,
      showModal: false,
    };
  },
  props: {
    detailInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...invoiceControlManagement,
    provider(ctx) {
      if (this.detailInfo.data_log.productos) {
        return this.detailInfo.data_log.productos;
      } else {
        return this.detailInfo.data_log.products;
      }
    },
  },
  watch: {},
};
</script>

<template>
  <b-container fluid class="p-0">
    <p>Tienda: {{ detailInfo.co }}</p>
    <p>Tipo de documento: {{ detailInfo.data_log.id_tipo_docto }}</p>
    <p>
      Nit Tercero:
      {{
        detailInfo.data_log.nit_tercero
          ? detailInfo.data_log.nit_tercero
          : detailInfo.data_log.nit
      }}
    </p>
    <p>
      Medio de Pago:
      {{
        detailInfo.data_log.payment_method ? detailInfo.data_log.payment_method : "PSE"
      }}
    </p>
    <p>Id lista de precios: {{ detailInfo.data_log.id_lista_precio }}</p>
    <p>
      Total a pagar:
      {{
        $formatDollar(
          detailInfo.initial_data
            ? detailInfo.initial_data.total_a_pagar
            : detailInfo.data_log.total_a_pagar
        )
      }}
    </p>

    <p v-if="detailInfo.data_log.email">Correo: {{ detailInfo.data_log.email }}</p>
    <BaseDatatable
      :provider="provider"
      :tableheaders="
        this.detailInfo.data_log.productos ? tableHeaders : tableHeadersEnglish
      "
      :filterOption="false"
    >
      <template #cell(und)="row"> {{ row.item.und.toUpperCase() }}</template>
      <template #cell(id_unidad_precio)="row">
        {{ row.item.id_unidad_precio.toUpperCase() }}</template
      >
      <template #cell(iva)="row"> {{ row.item.iva }}%</template>
      <template #cell(discount)="row"> {{ row.item.discount }}%</template>
      <template #cell(descuento)="row"> {{ row.item.descuento }}%</template>
    </BaseDatatable>
  </b-container>
  <!-- Detail modal -->
</template>
